import React from "react";

import { localizer } from '../../../../Translator'

import ConfirmShipmentImg from '../../../../images/postamail-logo-confirm.png';

import { Container, Grid } from "@material-ui/core";
import Typography from '@material-ui/core/Typography'
import { Button } from "@material-ui/core"
import { TableContainer, TableHead, TableBody, Paper } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import { TableStyled, TableRowStyled, TableRowHeaderStyled } from "../../../common/TableStyled.js";

import ScreenHeading from "../../../common/ScreenHeading.js";

import DateCustom from "../../../Utilities/DateCustom.js";
import { TableCellStyled } from "../../../common/TableStyled.js";

export class OutboxConfirmShipment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Represents global shipment list given by parent component to be updated
      shipments: [],
    }
  }
  
  componentDidMount() {
    this.setState({ shipments: this.props.shipments })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.shipments === this.props.shipments) return

    this.setState({ shipments: this.props.shipments })
  }

  /**
   * Setting the first message by user action
   */
  getActionText = () => {
    let text = "";

    switch (this.props.action.toUpperCase()) {
      case 'SEND':
        text = localizer.ShipmentSent + " " + localizer.Successful //localizer.Sent
        break;
      case 'SCHEDULE':
        text = localizer.ShipmentProgrammed + " " + localizer.Successful
        //text = localizer.Scheduled
        break;
      case 'STORE':
        text = localizer.ShipmentsSaved + " " + localizer.Successful
        //text = localizer.Saved
        break;
      default:
        break;
    }
    return text
  }

  /**
   * Setting the second message by user action
   */
  getActionContent = () => {
    let text = "";

    switch (this.props.action.toUpperCase()) {
      case 'SEND':
        break;
      case 'SCHEDULE':
        text = localizer.ConfirmationScheduledText + DateCustom.convertUTCToLocalTime(this.props.shipments[0].emissionTime)
        break;
      case 'STORE':
        text = localizer.ConfirmationStoredText
        break;
      default:
        break;
    }
    return text
  }

  mountDestinationAddress = (shipment) => {
    if (!shipment) return ""
    if (!shipment.destinationAddress) return ""
    
    let destinationaddress = shipment.destinationAddress.who + "\n" +
      shipment.destinationAddress.streetType + " " + shipment.destinationAddress.streetName + " " + shipment.destinationAddress.streetNumber + " " + shipment.destinationAddress.streetComplements + "\n" +
      shipment.destinationAddress.postalCode + " " + shipment.destinationAddress.locality
    return destinationaddress
  }

  renderTextWithBoldValues = (text, values = []) => {
    if (typeof text !== "string" || text.length === 0) return text

    const normalizedValues = values
      .filter(value => value !== null && value !== undefined && `${value}` !== "")
      .map(value => `${value}`)

    if (normalizedValues.length === 0) return text

    const escapedValues = [...new Set(normalizedValues)]
      .sort((a, b) => b.length - a.length)
      .map(value => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))

    if (escapedValues.length === 0) return text

    const regex = new RegExp(`(${escapedValues.join("|")})`, "g")
    const uniqueValues = new Set(normalizedValues)

    return text.split(regex).map((part, index) => (
      uniqueValues.has(part)
        ? <strong key={`bold-${index}`}>{part}</strong>
        : <React.Fragment key={`text-${index}`}>{part}</React.Fragment>
    ))
  }

  render() {
    const shipments = (Array.isArray(this.props.shipments) && this.props.shipments.length > 0)
      ? this.props.shipments
      : (Array.isArray(this.state.shipments) ? this.state.shipments : [])

    const batchLabel = !this.props.notNewShipment
      ? shipments
        .map(s => (s && (s.batchLabel || (s.shipment && s.shipment.batchLabel))) || null)
        .find(label => typeof label === "string" && label.trim() !== "") || null
      : null

    const confirmWithBatchText = localizer.formatString(
      localizer.ConfirmShipmentWithBatchText,
      shipments.length,
      batchLabel
    )

    const confirmShipmentNumberText = localizer.formatString(
      localizer.ConfirmShipmentNumber,
      shipments.length
    )

    return (
      <React.Fragment>
        <Container className="p-20">

          {/* Screen heading. */}
          <ScreenHeading className="typography-generic" icon={<i className="fa-solid fa-envelopes-bulk icon-button-header mr-20 ml-20"></i>} title={localizer.ShipmentsSuccessful} />

          <Grid container direction="row" className="container-generic" justify="center" justifycontent="center" alignitems="center">
            <Grid container item md={6} direction="row" justify="center" justifycontent="center" alignitems="center">
              <img src={ConfirmShipmentImg} alt="" width={200} height={200}></img>
            </Grid>

            <Grid container item md={6} >
              <Paper elevation={3} className="p-20" style={{ border: "solid 2px var(--custom-primary-color)" }}>
                <Grid container item={12} direction="row" justify="center" justifycontent="center" alignitems="center">
                  <i className="fa-solid fa-paper-plane font-size-30"></i>
                </Grid>
                <Grid item={12} className="mt-20">
                  <Typography className="typography-generic">{localizer.NewShipmentQuestionText}</Typography>
                </Grid>
                <Grid container item={12} className="mt-20" direction="row" justify="center" justifycontent="center" alignitems="center">
                  <Button className="button-generic primary" variant="contained" href="shipment">{localizer.NewShipmentText}</Button>
                </Grid>
              </Paper>
            </Grid>

            <Grid item md={12} className="mt-10">
              <Typography className="typography-generic shipment-confirm">{this.getActionText()}</Typography>
              <Typography className="typography-generic shipment-confirm">{this.getActionContent()}</Typography>
            </Grid>

            <Grid item md={12} className="mt-10">
              <Alert severity="info" fullWidth>
                {shipments.length > 0 && batchLabel && batchLabel !== "" ? (
                  <Typography className="typography-generic color-info" variant="caption" display="block" gutterBottom>
                    {this.renderTextWithBoldValues(confirmWithBatchText, [shipments.length, batchLabel])}
                  </Typography>
                ) : (
                  <React.Fragment>
                    <Typography className="typography-generic color-info" variant="caption" display="inline" gutterBottom>
                      {this.renderTextWithBoldValues(confirmShipmentNumberText, [shipments.length])}
                    </Typography>
                  </React.Fragment>
                )}
                
                <Typography className="typography-generic color-info" variant="caption" display="inline" gutterBottom>
                  {localizer.ConfirmShipmentText}
                </Typography>
              </Alert>
            </Grid>

            <Grid container direction="row" justify="center" alignItems="center" spacing={4} className="pt-25">
              <TableContainer component={Paper}>
                <TableStyled>
                  <TableHead>
                    <TableRowHeaderStyled>
                      <TableCellStyled className="typography-generic tablerow-header">{localizer.Shipment}</TableCellStyled>
                      <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.ShipmentCode}</TableCellStyled>
                      <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.ShipmentProgressStep3}</TableCellStyled>
                    </TableRowHeaderStyled>
                  </TableHead>
                  <TableBody>
                    {shipments.map((shipment, index) => (
                      <TableRowStyled key={shipment.shipmentCode}>
                        <TableCellStyled align="left" style={{ width: '10%' }} className="typography-generic tablerow-content">{localizer.Shipment}  {index + 1} </TableCellStyled>
                        <TableCellStyled align="center"><Typography className="typography-generic"><strong>{shipment.shipmentCode}</strong></Typography></TableCellStyled>
                        <TableCellStyled align="center"><Typography className="typography-generic">{this.mountDestinationAddress(shipment)}</Typography></TableCellStyled>
                      </TableRowStyled>
                    ))}
                  </TableBody>
                </TableStyled>
              </TableContainer>
            </Grid>


            {/* <Grid item md={6} style={{ borderRight: '1px solid' }}>
              <img src={CheckShipment} alt="" style={{ width: 100, position: "relative", left: "calc(50% - 50px)" }}></img>
              <br></br>
              <Typography className="typography-generic shipment-confirm">{this.getActionText()}</Typography>
              <br></br>
              <Typography className="typography-generic shipment-confirm">{this.getActionContent()}</Typography>
              <br></br>
              <br></br>
              <Typography className="typography-generic shipment-confirm">{localizer.ShipmentNewId}</Typography>
              <br></br>
              {this.state.shipments && this.state.shipments.map((shipment) => (
                <Typography key={shipment.shipmentCode} className="typography-generic shipment-confirm">{shipment.shipmentCode}<br></br></Typography>
              ))}
            </Grid>

            <Grid container item md={6}>
              <Grid container item md={3}></Grid>
              <GridNewShipment container item md={9} className="gridnewshipment">
                <Grid item md={3}>
                  <i className="fa-solid fa-paper-plane font-size-40 color-white"></i>
                </Grid>
                <Grid container item md={9}>
                  <Grid item md={12}>
                    <Typography className="typography-generic shipment-new">{localizer.NewShipmentQuestionText}</Typography>
                  </Grid>
                  <Grid item md={12} style={{ textAlign: 'right' }}>
                    <Button className="button-generic primary" variant="contained" href="shipment">{localizer.NewShipmentText}</Button>
                  </Grid>
                </Grid>
              </GridNewShipment>
            </Grid> */}

          </Grid>
        </Container>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipments/sections/summary/OutboxConfirmShipment.js